<template>
  <div class="card card-custom" :class="{'card-sticky': !noEffectTop, 'no-box': noBox}" :id="noEffectTop ? '' : 'kt_page_sticky_card'">
    <div class="card-header">
      <div class="card-title">
        <slot name="badge"></slot>
        <h3 class="card-label" style="margin-left: 5px;">{{ title }}</h3>
      </div>
      <div class="card-toolbar" v-if="exibirBotoes">
        <b-dropdown
          :disabled="loading"
          :variant="(fgModoPR == 'R' ? 'light-primary' : 'light-danger')"
          toggle-class="mr-2 font-weight-bolder"
          right
          text="Menu"
          v-if="botoesMenuFiltro.length"
        >
          <template slot="button-content">
            <i v-if="!loading" class="ki ki-more-ver icon-sm"></i>
            <b-spinner
              v-if="loading"
              small
              style="margin-bottom: 2px; margin-right: 3px;"
            ></b-spinner>
            Menu
          </template>
          <b-dropdown-item
            @click="$emit('botoesMenu', botaoMenu.evento)"
            v-for="botaoMenu in botoesMenuFiltro"
            :key="botaoMenu.evento"
          >
            {{ botaoMenu.title }}
          </b-dropdown-item>
        </b-dropdown>
        <a
          href="javascript:;"
          @click="voltar"
          class="btn font-weight-bolder mr-2"
          :class="{'btn-light-primary': fgModoPR == 'R', 'btn-light-danger': fgModoPR == 'P'}"
          :disabled="loading"
        >
          <b-spinner
            v-if="loading"
            small
            style="margin-bottom: 2px; margin-right: 3px;"
          ></b-spinner>
          <i v-if="!loading" class="ki ki-long-arrow-back icon-sm"></i> Voltar
        </a>
        <b-dropdown
          :disabled="loading"
          @click="salvar(0)"
          no-caret
          :variant="(fgModoPR == 'R' ? 'primary' : 'danger')"
          right
          split
          text="Salvar"
          split-class="font-weight-bolder"
        >
          <template slot="button-content">
            <i v-if="!loading" class="ki ki-check icon-sm"></i>
            <b-spinner
              v-if="loading"
              small
              style="margin-bottom: 2px; margin-right: 3px;"
            ></b-spinner>
            Salvar
          </template>
          <b-dropdown-item-button @click="salvar(1)">
            <i
              class="nav-icon flaticon2-reload"
              style="position: absolute;margin-top: -1px;"
            ></i>
            <span class="nav-text" style="margin-left: 26px;"
              >Salvar &amp; continuar</span
            >
          </b-dropdown-item-button>
          <b-dropdown-item-button @click="salvar(2)">
            <i
              class="nav-icon flaticon2-add-1"
              style="position: absolute;margin-top: -1px;"
            ></i>
            <span class="nav-text" style="margin-left: 26px;"
              >Salvar &amp; adicionar novo</span
            >
          </b-dropdown-item-button>
          <b-dropdown-item-button @click="salvar(0)">
            <i
              class="nav-icon flaticon2-search"
              style="position: absolute;margin-top: -1px;"
            ></i>
            <span class="nav-text" style="margin-left: 26px;"
              >Salvar &amp; sair</span
            >
          </b-dropdown-item-button>
        </b-dropdown>
      </div>
    </div>
    <div class="card-body">
      <b-form autocomplete="off">
        <slot></slot>
        <div class="row" style="margin-top: 1.75rem;">
          <div class="col-md-12">
            <DatasInclusaoAlteracao 
              :dataInclusao="DATA_INCLUSAO" 
              :dataAlteracao="DATA_ALTERACAO" 
              :usuarioInclusao="usuarioInclusao" 
              :usuarioAlteracao="usuarioAlteracao"
            />
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<style lang="scss">
  @media(max-width: 991px) {
    .card.card-custom.card-sticky .card-header {
      top: 55px !important;
    }
  }

  .no-box {
    box-shadow: none !important;
    margin-bottom: 0px;
  }
</style>

<script>
import { mapGetters } from "vuex";
import moment from "moment";

import DatasInclusaoAlteracao from "./DatasInclusaoAlteracao.vue";

export default {
  name: "FormCadastro",
  data() {
    return {
      timerHeader: null
    };
  },
  components: {
    DatasInclusaoAlteracao
  },
  mounted() {
    if (typeof window.KTLayoutStickyCard !== "undefined") {
      window.KTLayoutStickyCard.init("kt_page_sticky_card");
      this.timerHeader = setInterval(this.atualizarHeader, 1000);
    }
  },
  beforeDestroy() {
    if (this.timerHeader) {
      clearInterval(this.timerHeader);
    }
  },
  computed: {
    ...mapGetters([
      "fgModoPR"
    ]),
    DATA_INCLUSAO() {
      if (this.dataInclusao) {
        return moment(this.dataInclusao, "YYYY-MM-DD HH:mm:ss").format(
          "DD/MM/YYYY [às] HH:mm:ss"
        );
      } else {
        return "";
      }
    },
    DATA_ALTERACAO() {
      if (this.dataAlteracao) {
        return moment(this.dataAlteracao, "YYYY-MM-DD HH:mm:ss").format(
          "DD/MM/YYYY [às] HH:mm:ss"
        );
      } else {
        return "";
      }
    },
    botoesMenuFiltro() {
      return this.botoesMenu.filter(botao => botao.exibir);
    }
  },
  props: [
    "title",
    "loading",
    "exibirBotoes",
    "botoesMenu",
    "dataInclusao",
    "usuarioInclusao",
    "dataAlteracao",
    "usuarioAlteracao",
    "noBox",
    "noEffectTop"
  ],
  methods: {
    atualizarHeader() {
      window.KTLayoutStickyCard.update();
    },
    voltar() {
      this.$emit("voltar", {});
    },
    salvar(tipo) {
      this.$emit("salvar", tipo);
    }
  }
};
</script>
